import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import {
  SvgIcon,
  Box,
  Paper,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
  IconButton,
} from "@mui/material";
// import LogoutIcon from "@mui/icons-material/Logout";
import logo from "../../assets/images/active-aging-logo.png";
import { ReactComponent as MembersActiveIcon } from "../../assets/icons/members-icon-active.svg";
import { ReactComponent as MembersIcon } from "../../assets/icons/members-icon.svg";
import { ReactComponent as LogoutIcon } from "../../assets/icons/sign-out-icon.svg";
import { ReactComponent as BenefitsActiveIcon } from "../../assets/icons/benefits-icon-active.svg";
import { ReactComponent as BenefitsInactiveIcon } from "../../assets/icons/benefits-icon.svg";
import { ReactComponent as QuestionairesActiveIcon } from "../../assets/icons/questionnaires-icon-active.svg";
import { ReactComponent as QuestionairesInactiveIcon } from "../../assets/icons/questionnaires-icon.svg";
// import { ReactComponent as QuestionairesActiveIcon } from "../../assets/icons/questionaires-active.svg";
// import { ReactComponent as QuestionairesInactiveIcon } from "../../assets/icons/questionaires-inactive.svg";
// import MembersInactiveIcon from "../../assets/icons/members-inactive.svg";

import styles from "./SidebarStyles";
import useMediaQuery from "@mui/material/useMediaQuery";
//import the icon as a react component

const Sidebar: React.FC = () => {
  const { user, logout } = useAuth0();
  const location = useLocation();

  const handleLogout = () => {
    // const returnToUrl = window.location.origin;

    logout();
  };

  const isMobile = useMediaQuery("(max-width:1100px)");

  const isActive = (path: string) => location.pathname === path;

  const {
    sidebarContainer,
    logoContainer,
    activeMenuItem,
    inactiveMenuItem,
    sidebarListItems,
    logoutButton,
    listBox,
  } = styles;

  return (
    <Paper sx={sidebarContainer}>
      {!isMobile && (
        <Box sx={logoContainer}>
          <img src={logo} alt="logo" />
        </Box>
      )}
      <Box sx={listBox}>
        <List sx={sidebarListItems}>
          <ListItemButton
            component={Link}
            to="/participants"
            sx={isActive("/participants") ? activeMenuItem : inactiveMenuItem}
          >
            {isActive("/participants") ? (
              <MembersActiveIcon />
            ) : (
              <MembersIcon />
            )}
            <ListItemText primary="Participants" />
          </ListItemButton>

          <ListItemButton
            component={Link}
            to="/benefits"
            sx={isActive("/benefits") ? activeMenuItem : inactiveMenuItem}
          >
            {isActive("/benefits") ? (
              <BenefitsActiveIcon />
            ) : (
              <BenefitsInactiveIcon />
            )}
            <ListItemText primary="Benefits" />
          </ListItemButton>

          <ListItemButton
            component={Link}
            to="/questionaires"
            sx={isActive("/questionaires") ? activeMenuItem : inactiveMenuItem}
          >
            {isActive("/questionaires") ? (
              <QuestionairesActiveIcon />
            ) : (
              <QuestionairesInactiveIcon />
            )}
            <ListItemText primary="Questionaires" />
          </ListItemButton>
        </List>
        <ListItemButton
          onClick={handleLogout}
          component={Link}
          to="/"
          sx={logoutButton}
        >
          <LogoutIcon />
          <ListItemText primary="Logout" />
        </ListItemButton>
      </Box>
    </Paper>
  );
};

export default Sidebar;
